import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from "moment";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { ToggleButton } from 'primereact/togglebutton';
import { Calendar } from 'primereact/calendar';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Checkbox } from 'primereact/checkbox';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate, useLocation } from 'react-router-dom';
import { useApiHook } from '../Helper/ApiHook/apiHook';
import IDWOverlayPanel from './IDWOverlayPanel';
import CaseDetail from '../Default/CaseDetail';
import DoseSpot from '../Default/DoseSpot';
import Pharmacy from '../Default/Pharmacy';
import CaseState from '../Default/CaseState';
import Transaction from '../Default/Transaction';
import axios from "axios";
import './HADataGrid.css';


const HADataGrid = ({ config, bulkAction }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [emptyProduct, setEmptyProduct] = useState({});
    const [lookup, setLookup] = useState([]);
    const [nestedLookup, setNestedLookup] = useState([]);
    const [metaData, setMetaData] = useState([]);
    const [products, setProducts] = useState(null);
    const [productDialog, setProductDialog] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [selectedProductsDialog, setSelectedProductsDialog] = useState(false);
    const [infoProductDialog, setInfoProductDialog] = useState(false);
    const [doseSpotDialog, setDoseSpotDialog] = useState(false);
    const [caseDetDialog, setCaseDetDialog] = useState(false);
    const [caseEditDialog, setCaseEditDialog] = useState(false);
    const [pharmacyDialog, setPharmacyDialog] = useState(false);
    const [caseStateDialog, setCaseStateDialog] = useState(false);
    const [transactionDialog, setTransactionDialog] = useState(false);
    const [product, setProduct] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const toast = useRef(null);
    const dt = useRef(null);
    const [filters, setFilters] = useState(null);
    const [config_, setConfig_] = useState(null);
    const history = useNavigate();
    const [{ user }, dispatch] = useStateValue();
    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 768px)").matches
    )
    const [errors, setErrors] = useState({});

    const LoadLookup = () => {

        //model.columns.forEach((col) => {
        //    if (typeof (col.lookup) !== 'undefined' && col.lookup !== '') {
        //        var lookup = response.data.filter(val => val.groupName === col.lookup);;
        //        setLookup({ ...lookup, [col.lookup]: lookup });
        //    }
        //});

        if (typeof config.dropdownCols !== 'undefined') {
            if (config.dropdownCols.length > 0) {
                config.dropdownCols.forEach((item) => {

                    if (item.type === 'list') {
                        var lookup_ = lookup;
                        lookup_[item.key] = item.value;
                        setLookup(lookup_);
                        // setLookup({ ...lookup, [item.key]: item.value });
                    }

                    if (item.type === 'sql') {

                        if (typeof item.nestedDDL !== 'undefined' && item.nestedDDL != null) {

                            var nestedlookup_ = nestedLookup;
                            nestedlookup_.push(item.nestedDDL);
                            setNestedLookup(nestedlookup_);

                        }

                        const url = 'api/Crud/selectLookup';

                        const params = {
                            "tableName": config.tableName,
                            "selectSql": item.value,
                            "databaseName": config.databaseName,
                            "serverName": config.serverName,
                            "nuid": user.NUID
                        }
                        var endpoint = window.location.origin + '/' + url;
                        axios.post(endpoint, params)

                            .then(function (response) {
                                //handle success
                                if (response.data.status === "OK") {

                                    if (response.data.data.length > 0) {
                                        var lookup_ = lookup;
                                        lookup_[item.key] = response.data.data;
                                        setLookup(lookup_);
                                        //  setLookup({ ...lookup, [item.key]: response.data.data });
                                    }
                                    else {
                                        var lookup_ = lookup;
                                        lookup_[item.key] = [];
                                        setLookup(lookup_);
                                    }
                                }
                                else {
                                    var lookup_ = lookup;
                                    lookup_[item.key] = [];
                                    setLookup(lookup_);
                                    alert(response.data.errMsg);
                                }

                            })
                            .catch(function (response) {
                                //handle error
                                var lookup_ = lookup;
                                lookup_[item.key] = [];
                                setLookup(lookup_);
                                alert(response);
                                console.log(response);
                            });



                    }
                });
            }

        }

    }

    if (!String.prototype.format) {
        String.prototype.format = function () {
            var args = arguments;
            return this.replace(/{(\d+)}/g, function (match, number) {
                return typeof args[number] != 'undefined'
                    ? args[number]
                    : match
                    ;
            });
        };
    }

    const LoadNestedLookup = (key, val) => {


        if (typeof config.dropdownCols !== 'undefined') {
            if (nestedLookup.length > 0) {
                nestedLookup.forEach((item) => {

                    if (key === item.parentKey) {
                        if (item.type === 'sql') {


                            const url = 'api/Crud/selectLookup';

                            const params = {
                                "tableName": config.tableName,
                                "selectSql": item.value.format(val),
                                "databaseName": config.databaseName,
                                "serverName": config.serverName,
                                "nuid": user.NUID
                            }
                            var endpoint = window.location.origin + '/' + url;
                            axios.post(endpoint, params)

                                .then(function (response) {
                                    //handle success
                                    if (response.data.status === "OK") {

                                        if (response.data.data.length > 0) {
                                            var lookup_ = { ...lookup };
                                            lookup_[item.key] = response.data.data;
                                            setLookup(lookup_);
                                            //  setLookup({ ...lookup, [item.key]: response.data.data });
                                        }
                                        else {
                                            var lookup_ = { ...lookup };
                                            lookup_[item.key] = [];
                                            setLookup(lookup_);
                                        }
                                    }
                                    else {
                                        var lookup_ = { ...lookup };
                                        lookup_[item.key] = [];
                                        setLookup(lookup_);
                                        alert(response.data.errMsg);
                                    }

                                })
                                .catch(function (response) {
                                    //handle error
                                    var lookup_ = { ...lookup };
                                    lookup_[item.key] = [];
                                    setLookup(lookup_);
                                    alert(response);
                                    console.log(response);
                                });



                        }
                    }
                });
            }

        }

    }

    //useEffect(() => {

    //    if (typeof config.dropdownCols !== 'undefined') {
    //        if (nestedLookup.length > 0) {
    //            nestedLookup.forEach((item) => {

    //                LoadNestedLookup(item.parentKey, product[item.parentKey]);
    //            });

    //        }
    //    }

    //}, [product]);

    const url = 'api/Crud/Select';

    const params = {
        "tableName": config.tableName,
        "selectSql": config.selectSql,
        "databaseName": config.databaseName,
        "serverName": config.serverName,
        "history": config.historyFlag,
        "key": config.primaryKey,
        "nuid": user.NUID
    }

    const [{ status, loading, data, error }, callAPI] = useApiHook(url,
        {
            verb: "post",
            useCache: false,
            token: user.token,
            params: params
        });

    useEffect(() => {
        window
            .matchMedia("(min-width: 768px)")
            .addEventListener('change', e => setMatches(e.matches));
    }, []);

    useEffect(() => {
        callAPI();
        LoadLookup();
        setConfig_(config);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps



    useEffect(() => {

        if (config_ && JSON.stringify(config) !== JSON.stringify(config_)) {
            setConfig_(config);
            callAPI();
            LoadLookup();

        }
    }, [config]);


    useEffect(() => {

        if (status === 'fetched') {


            if (data.status === "OK") {
                let emptyProduct_ = {};
                let filters_ = [];
                data.metaData.map((col, i) => {
                    var obj = new Object();
                    obj.value = '';
                    obj.matchMode = 'contains';
                    filters_[col.column_name] = obj;

                    emptyProduct_[col.column_name] = (col.data_type === 'boolean' || col.data_type === 'bit') ? false : null;

                });
                setFilters(filters_);

                if (typeof config.defaultValues !== 'undefined' && config.defaultValues.length > 0) {
                    config.defaultValues.map((val, i) => {
                        var col = Object.keys(val);
                        emptyProduct_[col] = val[col];

                    });
                }

                setEmptyProduct(emptyProduct_);


                setProducts(data.data);

                if (config.selectSql !== '') {
                    let meta_ = [];
                    if (data.data.length > 0) {
                        var cols = Object.keys(data.data[0]);

                        var meta = data.metaData;

                        meta.map((col1, i) => {

                            cols.map((col2, j) => {

                                if (col1.column_name === col2) {
                                    meta_.push(col1);
                                    return false; // fj
                                }

                            });

                        });



                        setMetaData(meta_);
                    }

                    else {
                        setMetaData(data.metaData);
                    }
                }
                else {
                    setMetaData(data.metaData);
                }
            }
            else {
                alert(data.errMsg);

            }


        }
        else if (status === 'error') {
            console.log(data);
            alert(error);

        }
    }, [status])

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    const openNew = () => {

        setProduct(emptyProduct);
        setSubmitted(false);
        setProductDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setProductDialog(false);
        setInfoProductDialog(false);

    }

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    }

    const hideSelectedProductsDialog = () => {
        setSelectedProductsDialog(false);
    }

    const saveProduct = () => {

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setSubmitted(true);

        //  if (product.name.trim()) {
        let actionType = '';
        let _products = [...products];
        let _product = { ...product };
        if (product[config.primaryKey]) {

            actionType = 'Update';

        }
        else {

            actionType = 'Insert';
            if (typeof config.defaultValues !== 'undefined' && config.defaultValues.length > 0) {
                config.defaultValues.map((val, i) => {
                    var col = Object.keys(val);
                    _product[col] = val[col];

                });
            }

        }


        const url = 'api/Crud/Save';

        const params = {
            "data": _product,
            "metaData": metaData,
            "joinTables": typeof config.joinTables !== 'undefined' ? config.joinTables : false,
            "tableName": config.tableName,
            "databaseName": config.databaseName,
            "serverName": config.serverName,
            "history": config.historyFlag,
            "key": config.primaryKey,
            "maxKey": typeof config.maxKey !== 'undefined' ? config.maxKey : "",
            "actionType": actionType,
            "nuid": user.NUID
        }

        var endpoint = window.location.origin + '/' + url;
        axios.post(endpoint, params)

            .then(function (response) {
                //handle success
                if (response.data.status === "OK") {
                    var ID = response.data.lastInsertedID;

                    if (actionType === 'Insert') {
                        _product[config.primaryKey] = ID;
                        _products.push(_product);
                    }
                    else {
                        const index = findIndexById(product[config.primaryKey]);
                        _products[index] = _product;
                    }

                    toast.current.show({ severity: 'success', summary: 'Successfully Saved', detail: '', life: 3000 });

                    if (typeof config.postCallback !== 'undefined') {
                        config.postCallback();
                    }

                    setProducts(_products);
                    setProductDialog(false);
                    setProduct(emptyProduct);
                    callAPI();

                }
                else {
                    //  alert(RackSaveState.data.ErrMsg);
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: response.data.errMsg, life: 3000 });
                    setProductDialog(false);
                    setProduct(emptyProduct);
                }

            })
            .catch(function (response) {
                //handle error
                alert(response);
                console.log(response);
            });



    }

    const editProduct = (product) => {
        setProduct({ ...product });
        setProductDialog(true);

        if (typeof config.dropdownCols !== 'undefined') {
            if (nestedLookup.length > 0) {
                nestedLookup.forEach((item) => {

                    LoadNestedLookup(item.parentKey, product[item.parentKey]);
                });

            }
        }
    }

    const editCase = (product) => {
        setProduct({ ...product });
        setCaseEditDialog(true);

    }

    const confirmDeleteProduct = (product) => {
        setProduct(product);
        setDeleteProductDialog(true);
    }
    const confirmShowPopup = (product) => {
        setProduct({ ...product });
        setInfoProductDialog(true);
    }

    const deleteProduct = () => {


        let _product = { ...product };

        const url = 'api/Crud/Delete';

        const params = {
            "data": _product,
            "metaData": metaData,
            "joinTables": typeof config.joinTables !== 'undefined' ? config.joinTables : false,
            "tableName": config.tableName,
            "databaseName": config.databaseName,
            "serverName": config.serverName,
            "history": config.historyFlag,
            "key": config.primaryKey,
            "actionType": 'Delete',
            "nuid": user.NUID
        }

        var endpoint = window.location.origin + '/' + url;
        axios.post(endpoint, params)

            .then(function (response) {
                //handle success
                if (response.data.status === "OK") {

                    let _products = products.filter(val => val[config.primaryKey] !== product[config.primaryKey]);
                    setProducts(_products);
                    setDeleteProductDialog(false);
                    setProduct(emptyProduct);
                    callAPI();
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });

                }
                else {
                    setDeleteProductDialog(false);
                    setProduct(emptyProduct);
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: response.data.errMsg, life: 3000 });

                }

            })
            .catch(function (response) {
                //handle error
                alert(response);
                console.log(response);
            });

    }

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < products.length; i++) {
            if (products[i][config.primaryKey] === id) {
                index = i;
                break;
            }
        }

        return index;
    }


    const checkNonVisiableCol = (col) => {
        let found = false;
        for (let i = 0; i < config.nonVisiableCols.length; i++) {
            if (config.nonVisiableCols[i] === col) {
                found = true;
                break;
            }
        }

        return found;
    }
    const checkNonEditableCol = (col) => {
        let found = false;
        for (let i = 0; i < config.nonEditAbleCols.length; i++) {
            if (config.nonEditAbleCols[i] === col) {
                found = true;
                break;
            }
        }

        return found;
    }
    const checkReadOnlyCol = (col) => {
        let found = false;
        if (typeof config.readOnlyCols !== 'undefined') {
            for (let i = 0; i < config.readOnlyCols.length; i++) {
                if (config.readOnlyCols[i] === col) {
                    found = true;
                    break;
                }
            }
        }
        return found;
    }
    const getDisplayName = (col,mode) => {
        const colName = config.displayNames[col];
        let required =  false;
        if (config.requiredFields && config.requiredFields.includes(col))
        {
            required = true;
        }

        if (typeof colName !== 'undefined') {
            return (
                <>
                    {colName}
                    {mode === 'edit' ? required && <span style={{ color: 'red' }}>*</span> : null}
                </>
            );
        } else {
            return (
                <>
                    {col}
                    {mode === 'Edit' ? required && <span style={{ color: 'red' }}>*</span> : null}
                </>
            );
        }
    };

    const checkDropdown = (col) => {

        let found = false;
        if (typeof config.dropdownCols !== 'undefined') {
            for (let i = 0; i < config.dropdownCols.length; i++) {
                if (config.dropdownCols[i].key === col) {
                    found = true;
                    break;
                }
            }
        }
        return found;


    }
    const getColSize = (col) => {
        if (typeof config.colSize !== 'undefined') {
            let size = config.colSize[col]
            if (typeof size !== 'undefined') {
                return size;
            }
            else { return null; }
        }
        else { return null }
    }
    const createId = () => {
        let id = '';
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 5; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
    }

   
    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const confirmSelectedProducts = () => {
        setSelectedProductsDialog(true);
    }

    const SelectedProducts = () => {

        if (typeof bulkAction != 'undefined' && bulkAction !== null) {
            let _products = products.filter(val => !selectedProducts.includes(val));


            var res = bulkAction(selectedProducts, config, metaData).then(function (result) {

                //setProducts(_products);
                callAPI();
                setSelectedProductsDialog(false);
                setSelectedProducts(null);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });

            }).catch

        }

    }

    const onCategoryChange = (e) => {
        let _product = { ...product };
        _product['category'] = e.value;
        setProduct(_product);
    }

    const onInputChange = (e, name) => {
        // const val = (e.target && e.target.value) || '';

        const val = e.target.value;
        let _product = { ...product };
        _product[`${name}`] = val;

        setProduct(_product);

        LoadNestedLookup(name, val);

    }

    const onInputNumberChange = (e, name) => {
        const val = e.value || 0;
        let _product = { ...product };
        _product[`${name}`] = val;

        setProduct(_product);
    }

   

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>

                <div className="">

                    { config.allowNew ? <Button label="New" icon="pi pi-plus" className="p-button-sm p-button-outlined p-button-success  mr-2 ml-1" onClick={openNew} /> : null}
                    { config.selectMultiple ? <Button label={config.bulkActionName} icon="pi pi-check" className="p-button-sm p-button-outlined p-button-success" onClick={confirmSelectedProducts} disabled={!selectedProducts || !selectedProducts.length} /> : null }

                    {/* <span className="display-6 mx-0 my-1 m-2" style={{ fontSize: '16px', fontWeight: '500' }}>{config.title}</span>*/}
                </div>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (

            <React.Fragment>

                {/*<span className="p-input-icon-right mr-2 ">*/}
                {/*    <i className="pi pi-search" />*/}
                {/*    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />*/}

                {/*</span>*/}
                <IconField iconPosition="right" className='mr-2'>
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText v-model="value1" placeholder="Search" onInput={(e) => setGlobalFilter(e.target.value)} className="p-inputtext-sm" />
                </IconField>
                {config.showExport !== 'undefined' ? config.showExport === true ? <Button label="Export" icon="pi pi-upload" className="p-button-sm p-button-outlined p-button-success mr-3" onClick={exportCSV} /> : null : null}
                <Button icon="pi pi-refresh" severity="success" aria-label="refresh" onClick={callAPI} size="small" style={{ width:'2.0rem' }} />
            </React.Fragment>
        )
    }

    const imageBodyTemplate = (rowData) => {
        return <img src={`images/product/${rowData.image}`} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} alt={rowData.image} className="product-image" />
    }

    const priceBodyTemplate = (rowData) => {
        return formatCurrency(rowData.price);
    }

    const ratingBodyTemplate = (rowData) => {
        return <Rating value={rowData.rating} readOnly cancel={false} />;
    }

    
    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div>
                    {config.allowExpand ? <span className="pi pi-external-link p-1" onClick={() => confirmShowPopup(rowData)} style={{ cursor: 'pointer' }}></span> : null }
                    {config.allowEdit ? <span className="pi pi-user-edit p-1" onClick={() => editProduct(rowData)} style={{ cursor: 'pointer' }} ></span> : null }
                    {config.allowDelete ? <span className="pi pi-trash p-1" onClick={() => confirmDeleteProduct(rowData)} style={{ cursor: 'pointer' }}></span> : null }
                </div>
            </React.Fragment>
        );
    }
    
    const caseEditBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div>
                    <span className="pi pi-pen-to-square p-1" onClick={() => editCase(rowData)} style={{ cursor: 'pointer' }} ></span> 
                </div>
            </React.Fragment>
        );
    }
   
    const header = (
        <div className="table-header">
            <span className="display-6 mx-0 my-1" style={{ fontSize: '14px', fontWeight: '400' }}>{config.title}</span>
            <span className="p-input-icon-left ">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />

            </span>

        </div>
    );
    const productDialogFooter = (
        <React.Fragment>
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveProduct} />
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />

        </React.Fragment>
    );
    const deleteProductDialogFooter = (
        <React.Fragment>
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteProduct} />
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductDialog} />

        </React.Fragment>
    );
    const selectedProductsDialogFooter = (
        <React.Fragment>
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={SelectedProducts} />
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideSelectedProductsDialog} />


        </React.Fragment>
    );

    const checkboxTemplate = (rowData, column) => {
        return <Checkbox checked={rowData[column.field] === 1 ? true : false} readOnly={true}></Checkbox>;
    }

    const linkTemplate = (rowData, column) => {
        let link = checkLink(column.field);
        let url = link.url;
        let params = link.params;

        params.map((col, i) => {

            url = url + '/' + rowData[col];
        });

        return <a href='#' onClick={() => navigate(url)} >{rowData[column.field]}</a>;
    }

    const popupLinkTemplate = (rowData, column) => {
       
        if (column.field === 'dose_spot_patient_id') {
            return <a href='#' onClick={() => { setProduct(rowData); setDoseSpotDialog(true) }} >{rowData[column.field]}</a>;
        }
        else if (column.field === 'id') {
            return <a href='#' onClick={() => { setProduct(rowData); setCaseDetDialog(true); }} >{rowData[column.field]}</a>;
        }
        else if (column.field === 'pharmacy_id') {
            return <a href='#' onClick={() => { setProduct(rowData); setPharmacyDialog(true); }} >{rowData[column.field]}</a>;
            
        }
        else if (column.field === 'transaction_id') {
            return <a href='#' onClick={() => { setProduct(rowData); setTransactionDialog(true); }} >{rowData[column.field]}</a>;

        }
        
        else
        {
            return '';
        }

       
    }
    const iconTemplate = (rowData, column) => {
        return <Button type="button" icon="pi pi-external-link" className="p-button-secondary" onClick={(e) => this.showDialogViewIcon(e, rowData, column.field)}></Button>;

    }
    const DateTemplate = (rowData, column) => {
        return (rowData[column.field] === null || rowData[column.field] === '') ? '' : moment(rowData[column.field]).format("MM-DD-YYYY");
    }
    const displayBigText = (rowData, column) => {
        // console.log(rowData);
        return rowData[column.field] && <IDWOverlayPanel data={rowData[column.field]} />

    }
    const checkDataType = (type) => {

        if (type === 'varchar' || type === 'string') { return 'string' }
        else if (type === 'int' || type === 'int32' || type === 'int64' || type === 'int16') { return 'int' }
        else if (type === 'Float' || type === 'double') { return 'float' }
        else if (type === 'bit' || type === 'boolean' || type === 'bool' || type === 'sbyte') { return 'boolean' }
        else if (type === 'datetime' || type === 'date') { return 'datetime' }
    }

    const checkLink = (col) => {
        if (typeof config.links !== 'undefined') {
            let link = config.links[col];
            if (typeof link !== 'undefined') {
                return link;
            }
            else { return null; }
        }
        else { return null; }
    }
    const statusBodyTemplate = (rowData) => {
       // let status = <a href='javascript:return true;' style={{ color: 'whitesmoke' }} onClick={() => { setProduct(rowData); setPharmacyDialog(true); }} >{rowData['status']}</a>
       // return <Tag value={status} severity={getSeverity(rowData.status)} />;
        return <Button size="small" label={rowData.status} severity={getSeverity(rowData.status)} onClick={() => { setProduct(rowData); setCaseStateDialog(true); }} />
       
    };
    const getSeverity = (status) => {
       // enum('initiate', 'pending', 'assigned', 'info_needed', 'question_answered', 'submitted_to_pharmacy', 'needs_refund', 'refunded', 'diagnosed', 'prescribed', 'more_info', 'Payment_Declined', 'created', 'undiagnosed', 'cancelled')
        switch (status) {
            case 'undiagnosed':
                return 'danger';
            case 'cancelled':
                return 'danger';

            case 'prescribed':
                return 'success';

            case 'pending':
                return 'info';
            case 'diagnosed':
                return 'info';
            case 'assigned':
                return 'info';

            case 'info_needed':
                return 'warning';
            case 'more_info':
                return 'warning';
            case 'refunded':
                return 'warning';

        }
        return 'Primary';
    };

    const dynamicColumns = metaData.map((col, i) => {

        // const opt = col.multiFilter === true ? [...new Set(data.map(data => data[col.field]))] : [];
        // const colOptions = [];

        //opt.map(val => {
        //    return colOptions.push({ label: val, value: val });
        //});
        //column_name,data_type,character_maximum_length
        let size = getColSize(col.column_name);
        let link = checkLink(col.column_name);
        return (
            checkNonVisiableCol(col.column_name) === false ?

                <Column key={col.column_name + i}
                    field={col.column_name}
                    header={getDisplayName(col.column_name,'grid')} //toPascalCase(col.column_name)
                    sortable={true}
                    filter={true}
                    filterField={col.column_name}
                    filterMatchMode="contains"
                    showFilterMenu={false }
                    body={
                        //col.column_name === 'id' ? popupLinkTemplate
                        //    :
                        col.column_name === 'transaction_id' ? popupLinkTemplate
                        :
                            col.column_name === 'dose_spot_patient_id' ? popupLinkTemplate
                                :
                                col.column_name === 'pharmacy_id' ? popupLinkTemplate
                                    :
                                col.column_name === 'status' ? statusBodyTemplate
                                    : 
                        link !== null ? linkTemplate
                            : col.character_maximum_length > 200 || ((col.data_type === 'varchar' || col.data_type === 'nvarchar') && col.character_maximum_length === -1) ? size === null ? displayBigText : null
                                : checkDataType(col.data_type) === 'boolean' ? checkboxTemplate
                                    : checkDataType(col.data_type) === 'datetime' ? DateTemplate
                                        : null
                    }

                    style={{
                        minWidth: size !== null ? size : checkDataType(col.data_type) === 'boolean' ? '80px'
                            : checkDataType(col.data_type) === 'int' ? '80px'
                                : checkDataType(col.data_type) === 'datetime' ? '200px'
                                    : checkDataType(col.data_type) === 'string' ? '200px'
                                        : '150px',
                        maxWidth: size !== null ? size : checkDataType(col.data_type) === 'boolean' ? '100px'
                            : checkDataType(col.data_type) === 'int' ? '100px'
                                : checkDataType(col.data_type) === 'datetime' ? '250px'
                                    : checkDataType(col.data_type) === 'string' ? '600px'
                                        : '250px',
                        whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis'
                        /*  whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', maxWidth: '100%'*/
                    }} />
                : null
        );

    });



    const updateProperty = (property, value) => {
        let row = product;
        row[property] = value;
        setProduct(row);
    }
    const dateFormat = (dt_) => {
        if (dt_ !== null && dt_ !== '') {
            var d = new Date(dt_);
            var day = d.getDate();
            var month = d.getMonth() + 1;
            var year = d.getFullYear();

            if (day < 10) {
                day = '0' + day;
            }

            if (month < 10) {
                month = '0' + month;
            }

            let dt = month + '-' + day + '-' + year;
            return new Date(dt);
        }
        else { return null; }

    }
    const actionTemplate = (rowData) => {
        return (
            <React.Fragment>
                <i className="pi pi-angle-right mr-3" ></i>
            </React.Fragment>
        );
    }
    const cardFooter = (rowData) => (
        <span>
            <i className="pi pi-user-edit mr-3" onClick={() => editProduct(rowData)} tooltip="Edit"></i>
            <i className="pi pi-trash mr-3" onClick={() => confirmDeleteProduct(rowData)} tooltip="Delete"></i>
        </span>
    );


    function toPascalCase(str) {
        if (/^[\p{L}\d]+$/iu.test(str)) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
        return str.replace(
            /([\p{L}\d])([\p{L}\d]*)/giu,
            (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase()
        ).replace(/[^\p{L}\d]/giu, '');
    }

    const validate = () => {
        setErrors({})
        const newErrors = {};
        config.requiredFields && config.requiredFields.forEach((field) => {
            if (!product[field]) {
                newErrors[field] = `${field} is required`;
            }
        });
        return newErrors;
    };
    const rowClass = (data) => {
        if (typeof data.patient_state_id !== 'undefined' && typeof data.patient_zip !== 'undefined') {
            return {
                'missing-data-row': !data.patient_state_id || !data.patient_zip || data.patient_state_id === '' || data.patient_zip === ''
            };
        }
    };

    return (
        <div className="HA">
            <Toast ref={toast} />
            <style>{`
            .missing-data-row {
                background-color: #ffebee !important;
            }
            .missing-data-row:hover {
                background-color: #ffcdd2 !important;
            }
        `}</style>
            <span className="display-6" style={{ fontSize: '20px' }}>{config.title}</span>
            <div className="HAGrid card">
                {
                    config.toolbar !== 'undefined' ?
                        config.toolbar === true ? <Toolbar className="" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar> : null
                        : null
                }

                <DataTable ref={dt}
                    value={products}
                    selection={selectedProducts}
                    onSelectionChange={(e) => setSelectedProducts(e.value)}
                    selectionMode="checkbox"
                    dataKey={config.primaryKey}
                    paginator rows={25}
                    loading={loading}
                    loadingIcon='pi pi-spinner'
                    emptyMessage="No records found"
                    rowsPerPageOptions={[10, 20, 30, 50]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
                    globalFilter={globalFilter}
                    filters={filters}
                    filterDisplay="row"
                    //header={header}
                    //appendTo={document.body}
                    size="small"
                    scrollHeight="600px"
                    scrollable
                    sortIcon="null"
                    rowClassName={rowClass}
                //stripedRows
                // showGridlines
                //   tableStyle={{ minWidth: '50rem' }}
                >

                    {config.selectMultiple === true ? <Column selectionMode="multiple" headerStyle={{ Maxwidth: '1rem', textAlign: 'center' }} exportable={false}></Column> : null}
                    {config.allowEdit === false && config.allowDelete === false && config.allowExpand === false ? null : <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '4rem', maxWidth: '5rem', textAlign: 'center' }}></Column>}
                   {/* <Column body={caseEditBodyTemplate} exportable={false} style={{ minWidth: '2rem', maxWidth: '2rem', textAlign: 'center' }}></Column>*/}
                    {dynamicColumns}




                </DataTable>
            </div>



            <Dialog visible={deleteProductDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '4rem' }} />
                    {product && <span>Are you sure you want to delete <b>{product.name}</b>?</span>}
                </div>
            </Dialog>

            <Dialog visible={selectedProductsDialog} style={{ width: '450px' }} header="Confirm" modal footer={selectedProductsDialogFooter} onHide={hideSelectedProductsDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {product && <span>Are you sure you want to {config.bulkActionName} the selected products?</span>}
                </div>
            </Dialog>




            <Dialog
                visible={productDialog}
                style={{ width: '60%' }}
                header={config.title}
                modal
                className="p-fluid"
                footer={productDialogFooter}
                onHide={hideDialog}
                position={'center'}
                // contentStyle={{ maxHeight: (windowHeight - 250), width: '60vw', overflow: "auto" }}
                baseZIndex={10001}
            >
                {

                    <div className='row'>
                        {

                            metaData.map((col, index) => (
                                col.column_name !== config.primaryKey ?
                                    checkNonEditableCol(col.column_name) !== true ?
                                        <div key={col.column_name} className='col-md-12'>
                                            <div className="p-col-4" style={{ padding: '.2em' }}><label htmlFor={col.column_name}>{getDisplayName(col.column_name,'edit')}</label></div>
                                            <div className="p-col-8" style={{ padding: '.2em' }}>
                                                {checkDropdown(col.column_name) === true ?
                                                    <>
                                                    <Dropdown id={col.column_name} key={col.column_name} className={errors[col.column_name] ? 'p-invalid' : ''} filter options={typeof (lookup[col.column_name]) !== 'undefined' ? lookup[col.column_name] : []} optionLabel="label" optionValue="value" onChange={(e) => onInputChange(e, col.column_name)} value={product && (product[col.column_name] === null ? '' : product[col.column_name])} />
                                                    {errors[col.column_name] && <small className="p-error">{errors[col.column_name]}</small>}
                                                    </>
                                                    : (checkDataType(col.data_type) === 'string' && col.character_maximum_length <= 255) ?
                                                        <InputText id={col.column_name} key={col.column_name} className={errors[col.column_name] ? 'p-invalid' : ''} disabled={checkReadOnlyCol(col.column_name)} onChange={(e) => onInputChange(e, col.column_name)} value={product && (product[col.column_name] === null ? '' : product[col.column_name])} />
                                                        : (checkDataType(col.data_type) === 'string' && col.character_maximum_length > 255) ?
                                                            <InputTextarea rows={3} cols={30} className={errors[col.column_name] ? 'p-invalid' : ''} disabled={checkReadOnlyCol(col.column_name)} onChange={(e) => onInputChange(e, col.column_name)} value={product && (product[col.column_name] === null ? '' : product[col.column_name])} />
                                                            : (checkDataType(col.data_type) === 'string' && col.character_maximum_length < 0) ?
                                                                <InputTextarea rows={3} cols={30} className={errors[col.column_name] ? 'p-invalid' : ''} disabled={checkReadOnlyCol(col.column_name)} onChange={(e) => onInputChange(e, col.column_name)} value={product && (product[col.column_name] === null ? '' : product[col.column_name])} />
                                                                : (checkDataType(col.data_type) === 'int') ?
                                                                    <InputText id={col.column_name} type='number' className={errors[col.column_name] ? 'p-invalid' : ''} key={col.column_name} disabled={checkReadOnlyCol(col.column_name)} onChange={(e) => onInputChange(e, col.column_name)} value={product && (product[col.column_name] === null ? '' : product[col.column_name])} />

                                                                    : checkDataType(col.data_type) === 'datetime' ?
                                                                        <Calendar dateFormat="mm/dd/yy" className={errors[col.column_name] ? 'p-invalid' : ''} disabled={checkReadOnlyCol(col.column_name)} onChange={(e) => onInputChange(e, col.column_name)} value={product && (product[col.column_name] === null ? '' : dateFormat(product[col.column_name]))} showButtonBar={true}></Calendar>
                                                                        : checkDataType(col.data_type) === 'boolean' ?
                                                                        <>
                                                                            <ToggleButton className={errors[col.column_name] ? 'p-invalid' : ''} checked={product === null ? false : (product[col.column_name] === null ? false : product[col.column_name])} disabled={checkReadOnlyCol(col.column_name)} onChange={(e) => onInputChange(e, col.column_name)} />
                                                                            {errors[col.column_name] && <small className="p-error">{errors[col.column_name]}</small>}
                                                                            </>
                                                                            :
                                                                            <InputText id={col.column_name} key={col.column_name} className={errors[col.column_name] ? 'p-invalid' : ''} disabled={checkReadOnlyCol(col.column_name)} onChange={(e) => onInputChange(e, col.column_name)} value={product && (product[col.column_name] === null ? '' : product[col.column_name])} />
                                                }

                                            </div>
                                        </div>
                                        : null
                                    : null
                            ))

                        }

                    </div>


                }

            </Dialog>

            <Dialog
                visible={infoProductDialog}
                style={{ width: '60%' }}
                header={config.title}
                modal
                className="p-fluid"
                footer=""
                onHide={hideDialog}
                position={'center'}
                // contentStyle={{ maxHeight: (windowHeight - 250), width: '60vw', overflow: "auto" }}
                baseZIndex={10001}
            >
                {


                    <div className="d-flex flex-column align-items-start">
                        {
                            metaData.map((col, index) => (
                                col.column_name != config.primaryKey ?
                                    checkNonVisiableCol(col.column_name) !== true ?
                                        <>
                                            <div className='mb-1 display-6' style={{ fontSize: '18px', fontWeight: '600' }}>

                                                {getDisplayName(col.column_name,'grid')}

                                            </div>

                                            <div className="" style={{ whiteSpace: 'break-spaces', fontSize: '16px' }}>

                                                {product && product[col.column_name]}

                                            </div>
                                            <hr />

                                        </>
                                        : null
                                    : null
                            ))
                        }

                    </div>

                }

            </Dialog>

            <Dialog
                visible={doseSpotDialog}
                style={{ width: '80%' }}
                header={'DoseSpot Dashboard'}
                modal
                className="p-fluid"
                footer=""
                onHide={(e) => { setDoseSpotDialog(false); setProduct(null); }}
                position={'center'}
                // contentStyle={{ maxHeight: (windowHeight - 250), width: '60vw', overflow: "auto" }}
                baseZIndex={10001}
            >
                {

                    <div>
                        {product && <DoseSpot key={product.id} selectedCase={product} refresh={callAPI} />}
                    </div>

                }

            </Dialog>

            <Dialog
                visible={caseDetDialog}
                style={{ width: '90%' }}
                header={'Case Dashboard'}
                modal
                className="p-fluid"
                footer=""
                onHide={(e) => { setCaseDetDialog(false); setProduct(null); }}
                position={'center'}
                // contentStyle={{ maxHeight: (windowHeight - 250), width: '60vw', overflow: "auto" }}
                baseZIndex={10001}
            >
                {


                    <div>
                        {product ? (
                            <>
                                <CaseDetail key={product.id} selectedCase={product} refresh={callAPI} />
                            </>
                        ) : (
                            <p>Loading case details...</p>
                        )}
                    </div>

                }

            </Dialog>

            <Dialog
                visible={pharmacyDialog}
                style={{ width: '90%' }}
                header={'Pharmacy Dashboard'}
                modal
                className="p-fluid"
                footer=""
                onHide={(e) => { setPharmacyDialog(false); setProduct(null); }}
                position={'center'}
                // contentStyle={{ maxHeight: (windowHeight - 250), width: '60vw', overflow: "auto" }}
                baseZIndex={10001}
            >
                {


                    <div>
                        {product ? (
                            <>
                                <Pharmacy key={product.id} selectedCase={product} refresh={callAPI} />
                            </>
                        ) : (
                            <p>Loading pharmacy details...</p>
                        )}
                    </div>

                }

            </Dialog>

            <Dialog
                visible={caseStateDialog}
                style={{ minWidth: '800px' }}
                header={'Case State'}
                modal
                className="p-fluid"
                footer=""
                onHide={(e) => { setCaseStateDialog(false) }}
                position={'center'}
                // contentStyle={{ maxHeight: (windowHeight - 250), width: '60vw', overflow: "auto" }}
                baseZIndex={10001}
            >
                {product ? (
                    <>
                        <CaseState key={product.id} selectedCase={product} refresh={callAPI} />
                    </>
                ) : (
                    <p>Loading case details...</p>
                )}

            </Dialog>

            <Dialog
                visible={transactionDialog}
                style={{ minWidth: '800px' }}
                header={'Braintree Transaction'}
                modal
                className="p-fluid"
                footer=""
                onHide={(e) => { setTransactionDialog(false) }}
                position={'center'}
                // contentStyle={{ maxHeight: (windowHeight - 250), width: '60vw', overflow: "auto" }}
                baseZIndex={10001}
            >
                {product ? (
                    <>
                        <Transaction key={product.id} selectedCase={product} refresh={callAPI} />
                    </>
                ) : (
                        <p>Loading transaction details...</p>
                )}

            </Dialog>


        </div>
    );
}


export default HADataGrid;